import { pxToRem } from "@outschool/ui-utils";
import { SystemStyleObject } from "@styled-system/css";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";
import LegacyButton, { LegacyButtonVariant } from "./LegacyButton/LegacyButton";

export interface ToggleButtonProps extends Object {
  enabled: boolean;
  variant?: LegacyButtonVariant;
  sx?: SystemStyleObject;
}

export default React.forwardRef<any, any>(
  ({ enabled, ...props }: ToggleButtonProps, ref) => {
    const variant = props.variant || "contained";
    return (
      <LegacyButton
        ref={ref}
        {...props}
        variant={variant}
        color={enabled ? "primary" : "secondary"}
        sx={{
          padding: pxToRem(12),
          fontSize: pxToRem(16),
          borderWidth: "1px",
          ...(enabled
            ? {
                backgroundColor: "#6161f2",
                borderColor: "#6161f2",
                "&:hover:not(:disabled), &:focus:not(:disabled)": {
                  backgroundColor: "#6161f2",
                },
                "&:active:not(:disabled)": {
                  backgroundColor: "#6161f2",
                },
              }
            : {
                borderColor: "#CCCCCC",
                color: "text",
                "&:hover:not(:disabled), &:focus:not(:disabled)": {
                  color: "text",
                  borderColor: "#6161f2",
                  backgroundColor: "#E0E5FF",
                },
                "&:active:not(:disabled)": {
                  color: "text",
                },
              }),
          ...props.sx,
        }}
      />
    );
  }
);
